






import Vue from "vue";
import Game from "@/game/Game.vue";
import VuexTest from "@/components/VuexTest.vue";

export default Vue.extend({
  components: {
    Game
  }
});
